import type { Suggestion } from 'types/shared';

import { getVendorSuggestionStatus } from '../AutocompleteVendors/helpers';

import type { OrganizationFilterOption } from './types';

export const getOrganizationVendorSuggestions = (
  organizations: Suggestion[],
  vendors: Suggestion[],
  hasAccess: boolean,
  idPropertyName: 'id' | 'nameId' = 'id'
) => {
  const vendorOptions: OrganizationFilterOption[] = vendors.map((result) => ({
    description: result.nameId,
    icon: 'truck',
    id: result.id,
    label: result.uniqueName || result.name,
    nameId: result.nameId,
    status: getVendorSuggestionStatus(result),
    subLabel: 'Vendor',
    type: 'vendor',
    value: result[idPropertyName] || result.id,
  }));

  const organizationOptions: OrganizationFilterOption[] = (
    hasAccess ? organizations : []
  ).map((result) => ({
    description: 'Organization',
    icon: 'organization',
    id: result.id,
    label: result.uniqueName || result.name,
    nameId: result.nameId,
    status: 'organization',
    subLabel: 'Organization',
    type: 'organization',
    value: result[idPropertyName] || result.id,
  }));

  const results: OrganizationFilterOption[] = [
    ...vendorOptions,
    ...organizationOptions,
  ];

  return results;
};
